:host {
  align-items: center;
  display: flex;
  flex-flow: row wrap;
}

:host(.is-invalid) {
  input {
    border-color: var(--pine-color-border-danger);

    &:checked {
      background: var( --pine-color-danger);

      &:hover {
        background: var(--pine-color-danger-hover);
        border-color: var(--pine-color-border-danger-hover);
      }
    }

    &:focus-visible {
      outline-color: var(--pine-color-focus-ring-danger);
    }
  }

  label,
  .pds-checkbox__message--error {
    color: var(--pine-color-text-message-danger);
  }
}

:host(.is-indeterminate) {
  input {
    background: var(--pine-color-accent);
    border-color: var(--pine-color-accent);

    &:hover {
      background: var(--pine-color-accent);
      border-color: var(--pine-color-accent-hover);
    }

    &::after {
      /* stylelint-disable-next-line pine-design-system/prefer-semantic-tokens */
      border: 1px solid var(--pine-color-white);
      border-block-end: var(--pine-border-width-none);
      border-block-start: var(--pine-border-width-none);
      border-inline-start: var(--pine-border-width-none);
      content: "";
      display: block;
      height: 7px;
      inset-block-start: 50%;
      inset-inline-start: 50%;
      position: absolute;
      transform: translate(-50%, -50%) rotate(90deg);
      width: 4px;
    }
  }
}

input {
  appearance: none;
  background: var(--pine-color-background-container);
  border: var(--pine-border);
  border-radius: var(--pine-dimension-2xs);
  flex: none;
  height: var(--pine-dimension-sm);
  margin: 0;
  margin-block-start: var(--pine-dimension-025);
  position: relative;
  width: var(--pine-dimension-sm);

  &:hover {
    background: var(--pine-color-background-container-hover);
    border: var(--pine-border-hover);
  }

  &:checked {
    background: var(--pine-color-accent);
    border-color: var(--pine-color-accent);

    &:hover {
      background: var(--pine-color-accent-hover);
      border-color: var(--pine-color-accent-hover);
    }

    &::after {
      /* stylelint-disable-next-line pine-design-system/prefer-semantic-tokens */
      border: 1px solid var(--pine-color-white);
      border-block-start: var(--pine-border-width-none);
      border-inline-start: var(--pine-border-width-none);
      content: "";
      display: block;
      height: 7px;
      inset-block-start: 50%;
      inset-inline-start: 50%;
      position: absolute;
      transform: translate(-50%, -60%) rotate(43deg);
      width: 4px;
    }
  }

  &:disabled {
    background: var(--pine-color-background-container-disabled);
    border-color: var(--pine-color-border-disabled);
    cursor: not-allowed;

    &:checked {
      background: var(--pine-color-background-container-disabled);
      border-color: var(--pine-color-border-disabled);

      &::after {
        border-color: var(--pine-color-border);
      }
    }

    + label {
      cursor: not-allowed;
    }

    ~ .pds-checkbox__message {
      color: var(--pine-color-text-disabled);
    }
  }

  &:focus-visible {
    outline: var(--pine-outline-focus);
  }
}

:host-context([dir='rtl']) {
  input:checked::after {
    transform: translate(-50%, -60%) rotate(-43deg);
  }
}

label {
  display: flex;
  gap: var(--pine-dimension-xs);
}

.visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: polygon(0 0, 0 0, 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.pds-checkbox__message {
  color: var(--pine-color-text-message);
  font: var(--pine-typography-body-sm-medium);
  margin-block-start: 6px;
  margin-inline-start: var(--pine-dimension-md);
  width: 100%;
}

.pds-checkbox__message--error {
  display: flex;
  gap: var(--pine-dimension-2xs);

  pds-icon {
    margin-block-start: var(--pine-dimension-025);
  }
}
